<span id="top"></span>
<mat-toolbar class="mat-elevation-z2" id="toolbar">
  <button class="m-show menu-button" mat-icon-button (click)="open = !open">
    <mat-icon>menu</mat-icon>
  </button>
  <img
    src="/assets/final/logo_dark.png"
    [routerLink]="['/']"
    [ngClass]="{ 'm-hide': !showLogoOnToolbar }"
  />
  <span class="m-hide">
    <button mat-button [routerLink]="['/for-shoppers']">For Shoppers</button>
    <button mat-button (click)="scrollTo('howItWorks')" *ngIf="showHowItWorks">
      How It Works
    </button>
    <!-- <button mat-button [routerLink]="['/where-to-shop']">Where to Shop</button> -->
    <button mat-button [routerLink]="['/for-merchants']">For Merchants</button>
    <button mat-button (click)="showContact()">Contact Us</button
    ><a
      mat-raised-button
      class="call-to-action-login"
      href="https://app.zeropay.co.za/#/"
      target="_blank"
      >Login</a
    >&nbsp;
    <a
      mat-raised-button
      class="call-to-action"
      [href]="redirect"
      target="_blank"
      >Apply Now</a
    >
  </span>
</mat-toolbar>
<mat-drawer-container>
  <mat-drawer mode="over" [opened]="open">
    <div class="side-bar-header">
      <span></span>
    </div>
    <div class="side-bar-items">
      <a mat-button [routerLink]="['/']" (click)="open = false">Home</a>
      <a mat-button [routerLink]="['/for-shoppers']" (click)="open = false"
        >For Shoppers</a
      >
      <a
        mat-button
        [routerLink]="['/for-shoppers']"
        (click)="open = false"
        *ngIf="showHowItWorks"
        >How It Works</a
      >
      <!-- <a mat-button [routerLink]="['/where-to-shop']" (click)="open = false"
        >Where to Shop</a
      > -->
      <a mat-button [routerLink]="['/for-merchants']" (click)="open = false"
        >For Merchants</a
      >
      <a mat-button (click)="showContact()" (click)="open = false"
        >Contact Us</a
      >
      <a
        mat-raised-button
        class="call-to-action-login"
        href="https://app.zeropay.co.za/#/"
        target="_blank"
        >Login</a
      >
      <a
        mat-raised-button
        class="call-to-action"
        [href]="redirect"
        target="_blank"
        >Apply Now<mat-icon>chevron_right</mat-icon></a
      >
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <router-outlet></router-outlet>
    <div class="newsletter">
      <br />
      <div style="padding: 24px 16px">
        <h2>Stay in the know!</h2>
        <p>
          Want to find out more? Want to keep up to date on what we’re getting
          up to? Subscribe to our newsletter.
        </p>
        <br />
      </div>
      <form
        [formGroup]="subscribeForm"
        (ngSubmit)="submitSubscribe(subscribeForm)"
      >
        <div fxLayout="row wrap">
          <div fxFlex="100">
            <div style="position: relative">
              <input
                [disabled]="(loading && !subscribed) || subscribed"
                [readonly]="(loading && !subscribed) || subscribed"
                class="newsletter-input mat-elevation-z2"
                formControlName="email"
                placeholder="Email Address"
              />
              <button
                [disabled]="(loading && !subscribed) || subscribed"
                mat-raised-button
                type="submit"
                color="primary"
                class="mat-elevation-z0 subscribe"
                [ngClass]="{ subscribed: subscribed }"
                style="position: absolute; top: 6px; right: -24px"
              >
                <ng-container *ngIf="!loading && !subscribed">
                  Subscribe
                </ng-container>
                <ng-container *ngIf="subscribed">
                  Success&nbsp;<mat-icon>check_circle</mat-icon>
                </ng-container>
                <ng-container *ngIf="loading">
                  <mat-spinner [diameter]="24"></mat-spinner>
                </ng-container>
              </button>
            </div>
          </div>
        </div>
      </form>
      <br />
      <small
        >By signing up I agree to the
        <a
          target="_blank"
          href="https://drive.fevertreefinance.co.za/file/fetch/zeropay-privacy-policy"
          ><strong>Privacy Policy</strong></a
        >.</small
      >
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
    <footer class="footer" id="contact">
      <div class="ft-main">
        <div fxLayout="row wrap">
          <div fxFlex.gt-sm="20" fxFlex.lt-sm="100">
            <img
              src="/assets/final/logo_dark.png"
              width="100"
              class="footerImage"
            />
          </div>
          <div fxFlex.gt-sm="20" fxFlex.lt-sm="100">
            <h1 class="ft-title">For Shoppers</h1>
            <ul>
              <li>
                <button
                  mat-button
                  [routerLink]="['/for-shoppers']"
                  (click)="scrollTo('top')"
                >
                  How it works
                </button>
              </li>
              <!-- <li>
                <button mat-button [routerLink]="['/where-to-shop']">
                  Where to Shop
                </button>
              </li> -->
              <li>
                <button
                  mat-button
                  [routerLink]="['/shopper-faq']"
                  (click)="scrollTo('top')"
                >
                  Shopper FAQ's
                </button>
              </li>
              <li style="margin-top: 7px">
                <a
                  href="https://app.zeropay.co.za/#/"
                  style="
                    margin-left: 0px;
                    color: white;
                    font-weight: 450;
                    margin-top: 2px;
                  "
                  >Login</a
                >
              </li>
            </ul>
          </div>
          <div fxFlex.gt-sm="20" fxFlex.lt-sm="100">
            <h1 class="ft-title">For Merchants</h1>
            <ul>
              <li>
                <button
                  mat-button
                  [routerLink]="['/for-merchants']"
                  (click)="scrollTo('top')"
                >
                  How it works
                </button>
              </li>
              <li>
                <button
                  mat-button
                  [routerLink]="['/merchant-faq']"
                  (click)="scrollTo('top')"
                >
                  Merchant FAQ's
                </button>
              </li>
            </ul>
          </div>
          <div fxFlex.gt-sm="20" fxFlex.lt-sm="100">
            <h1 class="ft-title">Legal</h1>
            <ul>
              <li>
                <a
                  mat-button
                  href="https://drive.fevertreefinance.co.za/file/fetch/zeropay-terms-conditions"
                  target="_blank"
                  >Terms and Conditions</a
                >
              </li>
              <li>
                <a
                  mat-button
                  href="https://drive.fevertreefinance.co.za/file/fetch/zeropay-privacy-policy"
                  target="_blank"
                  >Privacy Policy</a
                >
              </li>
            </ul>
          </div>
          <div fxFlex.gt-sm="20" fxFlex.lt-sm="100">
            <h1 class="ft-title">Contact us</h1>
            <ul>
              <li>
                <a mat-button href="mailto:hello@zeropay.co.za">
                  <mat-icon [inline]="true">mail</mat-icon>&nbsp;hello@zeropay.co.za
                </a>
              </li>
              <li>
                <a mat-button href="tel:0872100336">
                  <mat-icon [inline]="true">phone</mat-icon>&nbsp;087 2100 336
                </a>
              </li>
              <li>
                <a mat-button href="tel:0605344283">
                  <mat-icon [inline]="true" svgIcon="whatsapp-icon" style="width: 15px;" ></mat-icon>&nbsp;060 5344 283 (message only)
                </a>
              </li>
              <!-- <li class="social-buttons"><a mat-button href=" https://www.facebook.com/ZeroPaySA"><mat-icon>facebook</mat-icon></a></li> -->
              <li class="social-buttons">
                <a
                  style="color: white"
                  href=" https://www.facebook.com/ZeroPaySA"
                  target="_blank"
                  ><mat-icon style="font-size: 31px">facebook</mat-icon></a
                >&nbsp;&nbsp;&nbsp;&nbsp;<a
                  href="https://www.instagram.com/zeropaysa/"
                  target="_blank"
                  ><mat-icon style="font-size: 31px"
                    ><img src="assets/instagram-brands.svg" /></mat-icon
                ></a>
              </li>
              <li class="social-buttons">
                <br />
                <a
                  href="https://play.google.com/store/apps/details?id=co.za.zeropay.app"
                  target="_blank"
                >
                  <img
                    src="/assets/images/google.png"
                    style="height: 40px; width: auto"
                  />
                </a>
              </li>
              <li class="social-buttons">
                <a
                  href="https://apps.apple.com/us/app/zeropay/id1591883815"
                  target="_blank"
                >
                  <img src="/assets/images/apple.svg" />
                </a>
              </li>

              <!-- <i class="fab fa-facebook"></i>
              <i class="fab fa-instagram"></i> -->
              <!-- <li class="social-buttons"><a mat-button href="https://www.instagram.com/mediwallet/">
                <img style="width: 9%;" src="/assets/instagram-brands.svg" /></a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <p class="ZeropayTag">
        ZeroPay is operated by FeverTree Finance (Pty) Ltd, an Authorised
        Financial Services Provider (FSP44281) and Registered Credit Provider
        (NCRCP19967).
      </p>
    </footer>
  </mat-drawer-content>
</mat-drawer-container>

<button
  [matTooltipDisabled]="!displayScrollToTop"
  [disabled]="!displayScrollToTop"
  mat-fab
  class="btn-to-top"
  matTooltip="Back to top"
  matTooltipPosition="before"
  [ngClass]="{ 'btn-to-top-show': displayScrollToTop }"
  (click)="scrollTo('top')"
>
  <mat-icon>keyboard_arrow_up</mat-icon>
</button>

<fevertree-support
  cellNumber="+27872100336"
  email="support@zeropay.co.za"
  [topicOptions]="['Sign Up', 'Accounts', 'Spending', 'Add Partner']"
  cc=""
  bcc="developers@fevertreefinance.co.za;annemie@fevertreefinance.co.za"
  sourceImage="/assets/final/logo_dark.png"
  sourceName="ZeroPay"
  backgroundColor="#f15855"
  speedDialBackgroundColor="rgb(26, 39, 89)"
  foregroundColor="rgb(240, 240, 240)"
  speedDialForegroundColor="rgb(240, 240, 240)"
  formFieldAppearance="standard"
  dialogTitleText="How can we help you?"
  dialogInfoText="<br/>“To give real service you must add something which cannot be bought or measured with money, and that is sincerity and integrity.”"
  icon="contact_support"
  tooltip="Support"
  phoneTooltip="Call us"
  emailTooltip="Email us"
  [selectedOption]="selectedReason"
  [prefilledMessage]="prefilledMessage"
>
</fevertree-support>
